Uint8Array.prototype.concat = function (other: Uint8Array) {
  const tmp = new Uint8Array(this.length + other.length);
  tmp.set(this, 0);
  tmp.set(other, this.length);
  return tmp;
};

export const COMMANDS = {
  NEW_LINE: new Uint8Array([0x0a]),
  PARTIAL_CUT_1: new Uint8Array([0x1d, 0x56, 0x42, 0x00]),
  FONT_B: new Uint8Array([0x1b, 0x4d, 49]),
  TAB_SIZE_SET: new Uint8Array([0x1b, 0x44, 2]),

  FONT_SIZE_NORMAL: new Uint8Array([0x1d, 0x21, 0x00]), // 1x base size
  FONT_SIZE_M: new Uint8Array([0x1d, 0x21, 0x10]), // 1.75x base size
  FONT_SIZE_L: new Uint8Array([0x1d, 0x21, 0x11]), // 2x base size
  FONT_SIZE_XL: new Uint8Array([0x1d, 0x21, 0x33]), // 4x base size

  BOLD_SET: new Uint8Array([0x1b, 0x45, 0x01]),
  BOLD_RESET: new Uint8Array([0x1b, 0x45, 0x00]),
  UNDERLINE_SET: new Uint8Array([0x1b, 0x2d, 0x01]),
  UNDERLINE_RESET: new Uint8Array([0x1b, 0x2d, 0x00]),

  CENTER_JUSTIFICATION: new Uint8Array([0x1b, 0x61, 0x01]),
  LEFT_JUSTIFICATION: new Uint8Array([0x1b, 0x61, 0x00]),
  RIGHT_JUSTIFICATION: new Uint8Array([0x1b, 0x61, 0x02]),

  DRAW_LINE: new Uint8Array(
    new TextEncoder().encode(Array(56).fill("-").join(""))
  ),

  // To print the EUR currency symbol, we have to expect strings to be encoded according to code page 858.
  ASCII_ENCODING: new Uint8Array([0x1c, 0x28, 0x43, 0x02, 0x00, 0x30, 0x01]),
  CODE_PAGE_858: new Uint8Array([0x1b, 0x74, 19]),

  ENGLISH_CHARS: new Uint8Array([0x1b, 0x52, 0x00]),
};

export const reset = COMMANDS.BOLD_RESET.concat(COMMANDS.UNDERLINE_RESET)
  .concat(COMMANDS.LEFT_JUSTIFICATION)
  .concat(COMMANDS.FONT_SIZE_NORMAL);

export const setup = COMMANDS.FONT_SIZE_NORMAL.concat(COMMANDS.FONT_B)
  .concat(COMMANDS.TAB_SIZE_SET)
  .concat(COMMANDS.ASCII_ENCODING)
  .concat(COMMANDS.CODE_PAGE_858)
  .concat(reset);

export const feedAndCut = COMMANDS.NEW_LINE.concat(COMMANDS.PARTIAL_CUT_1);
